import LocalizationKeys from './LocalizationKeys'

const English = {
  [LocalizationKeys.Page.Login.Title]: 'Login',
  [LocalizationKeys.Page.Login.Submit]: 'Login',

  [LocalizationKeys.Page.Register.Title]: 'Register',
  [LocalizationKeys.Page.Register.Submit]: 'Register',

  [LocalizationKeys.Page.ForgotPassword.Title]: 'Forgot password',
  [LocalizationKeys.Page.ForgotPassword.Submit]: 'Submit',
  [LocalizationKeys.Page.ForgotPassword.Processed]:
    'You will receive an email with a reset password link.',
  [LocalizationKeys.Page.ForgotPassword.AlreadyHaveAccount]:
    'Already have an account? Login',

  [LocalizationKeys.Page.ResetPassord.Title]: 'Reset password',
  [LocalizationKeys.Page.ResetPassord.Submit]: 'Submit',
  [LocalizationKeys.Page.ResetPassord.WrongUrlParameters]:
    'Wrong parameters in URL',
  [LocalizationKeys.Page.ResetPassord.Success]:
    'Password reset successfully. You can proceed to login.',
  [LocalizationKeys.Page.ResetPassord.Failure]:
    'Failure while resetting your password. Try again later',

  [LocalizationKeys.Page.ProfilesPage.Title]: 'Hello {{name}}',
  [LocalizationKeys.Page.ProfilesPage.SubscriptionActivated]:
    'Your subscription is activated',

  [LocalizationKeys.Page.ContactsPage.Title]: 'Audience',
  [LocalizationKeys.Page.ContactsPage.Username]: 'Username',
  [LocalizationKeys.Page.ContactsPage.IsFollowing]: 'Is following',
  [LocalizationKeys.Page.ContactsPage.FollowersCount]: 'Followers count',
  [LocalizationKeys.Page.ContactsPage.LastStoryMention]: 'Last story mention',
  [LocalizationKeys.Page.ContactsPage.LastInteraction]: 'Last interaction',
  [LocalizationKeys.Page.ContactsPage.FirstInteraction]: 'First interaction',

  [LocalizationKeys.Page.AutomationPage.Title]: 'Story mention answers',
  [LocalizationKeys.Page.AutomationPage.Status]:
    'Your automation is {{status}}',
  [LocalizationKeys.Page.AutomationPage.StatusLive]: 'live',
  [LocalizationKeys.Page.AutomationPage.StatusScheduled]: 'scheduled',
  [LocalizationKeys.Page.AutomationPage.StatusPaused]: 'paused',
  [LocalizationKeys.Page.AutomationPage.Settings]: 'Settings',
  [LocalizationKeys.Page.AutomationPage.Save]: 'Save',
  [LocalizationKeys.Page.AutomationPage.Edit]: 'Edit',

  [LocalizationKeys.Page.ProfileSettingsPage.Title]: 'Settings',
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramUserID]:
    'Instagram user ID: ',
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramUsername]:
    'Instagram username: ',
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramPermissions]:
    'Instagram permissions: ',
  [LocalizationKeys.Page.ProfileSettingsPage.DangerZone]: 'Danger zone',
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteButton]: 'Delete',
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteExplanation]:
    'Delete the Instagram account from your Echow account. The automation will stop to work immediately and all associated resources will be immediately deleted. Your subscription will be cancelled. This cannot be undone.',
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteProfil]: 'Delete profile',
  [LocalizationKeys.Page.ProfileSettingsPage.PlanAndBilling]: 'Plan & Billing',

  [LocalizationKeys.Page.UserProfilePage.Title]: 'My profile',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountTitle]:
    'Delete my account & all my profiles',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountDescription]:
    'This action will remove your account and all your Instagram profiles. This action immediately stops all automations and deletes all your data from our platform. This action is irreversible.',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountConfirmation]:
    'Are you sure to delete your account ? All your data will be deleted. This action is immediate and irreversible.',
  [LocalizationKeys.Page.UserProfilePage.AccountDeleted]:
    'Your account has been successfully deleted',

  [LocalizationKeys.Page.OnboardingRegistrationPage.Error]: 'Error',
  [LocalizationKeys.Page.OnboardingRegistrationPage.DescriptionError]:
    'Error while creating your account. Contact support if the error persists.',
  [LocalizationKeys.Page.OnboardingRegistrationPage.Back]: 'Back',
  [LocalizationKeys.Page.OnboardingRegistrationPage.HappyToSeeYou]:
    'Happy to see you again 🚀',

  [LocalizationKeys.Page.OnboardingStepsIndustryPage.FieldActivity]:
    'What is your field of activity',
  [LocalizationKeys.Page.OnboardingStepsIndustryPage.CheckMention]:
    'By checking this box, I acknowledge that I have read and accept without reservation <0>General Conditions of Use (GCU)</0> and <1>Privacy Policy</1> .',
  [LocalizationKeys.Page.OnboardingStepsIndustryPage.Continue]: 'Continue',

  [LocalizationKeys.Page.OnboardingStepsNamePage.Name]: 'Your full name',

  [LocalizationKeys.Page.OnboardingStepsEmailPage.Email]:
    'What is your email address',

  [LocalizationKeys.Page.OnboardingStepsPasswordPage.Password]:
    'Create a password',

  [LocalizationKeys.Page.ProfileFormDeletePage.Delete]:
    'Are you sure to delete ?',
  [LocalizationKeys.Page.ProfileFormDeletePage.AllDataDelete]:
    'All related resources (automations, answers, analytics data, ...) will be also permanently deleted. Your subscription will be immediately cancelled. This cannot be undone.',
  [LocalizationKeys.Page.ProfileFormDeletePage.InputConfirmation]:
    'Input {{ itemName }} to confirm',

  [LocalizationKeys.Layout.ProfileHeader.Audience]: 'Audience',
  [LocalizationKeys.Layout.ProfileHeader.Campaigns]: 'Campaigns',
  [LocalizationKeys.Layout.ProfileHeader.Automation]: 'Automation',
  [LocalizationKeys.Layout.ProfileHeader.Activity]: 'Activity',
  [LocalizationKeys.Layout.ProfileHeader.Settings]: 'Settings',

  [LocalizationKeys.Layout.RightHeader.Profile]: 'Profile',
  [LocalizationKeys.Layout.RightHeader.Settings]: 'Settings',
  [LocalizationKeys.Layout.RightHeader.Lang]: 'Lang',
  [LocalizationKeys.Layout.RightHeader.Legal]: 'Legal informations',
  [LocalizationKeys.Layout.RightHeader.Logout]: 'Logout',

  [LocalizationKeys.Component.Answer.Analytics.TotalSent]: 'Total sent',
  [LocalizationKeys.Component.Answer.Analytics.OpeningRate]: 'Opening rate',
  [LocalizationKeys.Component.Answer.Card.IfUserIsFollower]:
    'If the user follows your account',
  [LocalizationKeys.Component.Answer.Card.IfUserIsNotFollower]:
    "If the user doesn't follow your account",
  [LocalizationKeys.Component.Answer.List.ButtonInteractions]:
    'Buttons interactions',
  [LocalizationKeys.Component.Answer.List.Attachments]: 'Attachments',

  [LocalizationKeys.Component.Automation.Update.Status]: 'Automation status',
  [LocalizationKeys.Component.Automation.Update.ReactionLabel]:
    'Automation ♥ reaction',
  [LocalizationKeys.Component.Automation.Update.ReactionHelp]:
    'Automatically like the story mention.',
  [LocalizationKeys.Component.Automation.Update.MessageDelayLabel]:
    'Message Delay',
  [LocalizationKeys.Component.Automation.Update.MessageDelayHelp]:
    'Set delay between individual replies to avoid spamming.\nMin: 0\nMax: 15',
  [LocalizationKeys.Component.Automation.Update.Follower]: 'Follower',
  [LocalizationKeys.Component.Automation.Update.NonFollower]: 'Non follower',
  [LocalizationKeys.Component.Automation.Update.ReplyDelayLabel]: 'Reply delay',
  [LocalizationKeys.Component.Automation.Update.ReplyDelayHelp]:
    'Time before starting the automation after receiving the story mention, based on contact type.\nMin: 0\nMax: 2880 (48h)',
  [LocalizationKeys.Component.Automation.Update.ReplyLimitLabel]: 'Reply limit',
  [LocalizationKeys.Component.Automation.Update.ReplyLimitHelp]:
    'Time before the automation triggers again for the same contact, based on contact type.\nMin: 0\nMax: 2880 (48h)',

  [LocalizationKeys.Component.Profile.AddCard.ConnectError]:
    'An error occurred while connecting your Instagram account.',
  [LocalizationKeys.Component.Profile.AddCard.RegisterError]: 'Error',
  [LocalizationKeys.Component.Profile.AddCard.RegisterErrorDetails]:
    'There was an error while creating your profile. Try again or contact support if the error persists.',
  [LocalizationKeys.Component.Profile.AddCard
    .RegisterErrorDetailsAlreadyConnected]:
    'This instagram account is already connected to an Echow account',
  [LocalizationKeys.Component.Profile.AddCard.TryAgain]: 'Try again',
  [LocalizationKeys.Component.Profile.AddCard.Connect]: 'Connect account',
  [LocalizationKeys.Component.Profile.AddCard.Awaiting]:
    'Awaiting Instagram response',
  [LocalizationKeys.Component.Profile.AddCard.Creating]: 'Creating profile',

  [LocalizationKeys.Component.Profile.BillingPortal.BillingPortal]:
    'Manage my Plan',

  [LocalizationKeys.Component.Profile.ConnectFlow.AddInstagramAccount]:
    'Connect your Instagram account',
  [LocalizationKeys.Component.Profile.ConnectFlow.CheckMention]:
    'I acknowledge that I have read and accept without reservation <0>the General Subscription Conditions (GSC)</0>.',
  [LocalizationKeys.Component.Profile.ConnectFlow.LoginWithInstagram]:
    'LOGIN WITH INSTAGRAM',
  [LocalizationKeys.Component.Profile.ConnectFlow.Welcome]: 'Welcome to Echow',
  [LocalizationKeys.Component.Profile.ConnectFlow.ChoosePlan]:
    'Choose a plan to complete your registration',
  [LocalizationKeys.Component.Profile.ConnectFlow.InstagramConnection]:
    'By connecting your Instagram account to Echow, you benefit from a tool dedicated to managing your Story mention. Your data is strictly secured and used only to improve your experience on the platform.',

  [LocalizationKeys.Auth.Error.LoginError]:
    'Ensure your credentials are correct. Try again later if the error persists.',

  [LocalizationKeys.Component.Subscription.StatusTag.Trial]:
    '{{dayRemaining}} trial day(s) left',
  [LocalizationKeys.Component.Subscription.StatusTag.Paused]: 'Paused plan',
  [LocalizationKeys.Component.Subscription.StatusTag.PaymentRequired]:
    'Payment required',
  [LocalizationKeys.Component.Subscription.StatusTag.Canceled]: 'Canceled plan',
  [LocalizationKeys.Component.Subscription.StatusTag.PaymentError]:
    'Payment error',

  [LocalizationKeys.Component.Subscription.InvoicesCard.ViewAllInvoices]:
    'View all invoices',

  [LocalizationKeys.Component.Subscription.SummaryCard.Plan]:
    '{{planName}} plan',
  [LocalizationKeys.Component.Subscription.SummaryCard.NextPayment]:
    'Next payment on {{date}}',
  [LocalizationKeys.Component.Subscription.SummaryCard.Monthly]: 'month',
  [LocalizationKeys.Component.Subscription.SummaryCard.Annual]: 'year',
  [LocalizationKeys.Component.Subscription.SummaryCard.SaveWithAnnualPayment]:
    'Save 2 months of subscription with annual payment',

  [LocalizationKeys.Component.Profile.Card.AutomationIsLive]:
    'Automation is live',
  [LocalizationKeys.Component.Profile.Card.AutomationIsPaused]:
    'Automation is paused',
  [LocalizationKeys.Component.Profile.Card.ChoosePlanForUser]:
    'Choose a plan for {{username}}',

  [LocalizationKeys.Misc.Error.Required]: 'This field is required',
  [LocalizationKeys.Misc.Error.TypeString]: 'Input is not a valid string',
  [LocalizationKeys.Misc.Error.TypeNumber]: 'Input is not a valid number',
  [LocalizationKeys.Misc.Error.TypeLink]: 'Input is not a valid link',
  [LocalizationKeys.Misc.Error.TypeEmail]: 'Input is not a valid email',
  [LocalizationKeys.Misc.Error.NotValidPhone]: 'Phone number must be valid',
  [LocalizationKeys.Misc.Error.MinLength]:
    'The value must have at least {{length}} characters',
  [LocalizationKeys.Misc.Error.Caps]:
    'The value must contain at least one capital letter',
  [LocalizationKeys.Misc.Error.Lowercase]:
    'The value must contain at least one lowercase letter',
  [LocalizationKeys.Misc.Error.ContainsNumber]:
    'The value must have at least one number',
  [LocalizationKeys.Misc.Error.ContainsSymbol]:
    'The value must have at least one symbol',
  [LocalizationKeys.Misc.Error.MismatchValue]:
    'The value mismatch the expected value',

  [LocalizationKeys.Misc.Form.Title]: 'Title',
  [LocalizationKeys.Misc.Form.Description]: 'Description',
  [LocalizationKeys.Misc.Form.Name]: 'Name',
  [LocalizationKeys.Misc.Form.Slug]: 'Slug',
  [LocalizationKeys.Misc.Form.FirstName]: 'First name',
  [LocalizationKeys.Misc.Form.LastName]: 'Last name',
  [LocalizationKeys.Misc.Form.Username]: 'Username',
  [LocalizationKeys.Misc.Form.Email]: 'Email',
  [LocalizationKeys.Misc.Form.Phone]: 'Phone',
  [LocalizationKeys.Misc.Form.Password]: 'Password',
  [LocalizationKeys.Misc.Form.PasswordConfirmation]: 'Password confirmation',
  [LocalizationKeys.Misc.Form.RememberMe]: 'Remember me',
  [LocalizationKeys.Misc.Form.Add]: 'Add',
  [LocalizationKeys.Misc.Form.Label]: 'Label',
  [LocalizationKeys.Misc.Form.URL]: 'URL',
  [LocalizationKeys.Misc.Form.Message]: 'Message',
  [LocalizationKeys.Misc.Form.Minutes]: 'minutes',
  [LocalizationKeys.Misc.Form.Seconds]: 'seconds',
  [LocalizationKeys.Misc.Form.Hours]: 'hours',

  [LocalizationKeys.Misc.Form.Attachment]: 'Attachment',
  [LocalizationKeys.Misc.Form.AddAttachment]: 'Add attachment',
  [LocalizationKeys.Misc.Form.FileSizeExceeds]:
    'File size exceeds the authorized maximum size',
  [LocalizationKeys.Misc.Form.FileClicOrDrag]:
    'Click or drag the file to this area',
  [LocalizationKeys.Misc.Form.FileCanBe]: 'The file can be either: ',
  [LocalizationKeys.Misc.Form.FileMaxSize]: 'Max size 10Mb',
  [LocalizationKeys.Misc.Form.Buttons]: 'Buttons',
  [LocalizationKeys.Misc.Form.AddButtonInteraction]: 'Add button interaction',

  [LocalizationKeys.Misc.Form.AreYouSureToDelete]:
    'Are you sure you want to delete this resource ?',

  [LocalizationKeys.Misc.Button.Update]: 'Update',
  [LocalizationKeys.Misc.Button.Delete]: 'Delete',
  [LocalizationKeys.Misc.Button.Save]: 'Save',
  [LocalizationKeys.Misc.Button.Cancel]: 'Cancel',
  [LocalizationKeys.Misc.Button.Help]: 'Help',

  [LocalizationKeys.SBRM.EntityNotDefined]:
    'Choose what to do first and come back later',
  [LocalizationKeys.SBRM.Close]: 'Close',
  [LocalizationKeys.SBRM.Delete]: 'Delete',
  [LocalizationKeys.SBRM.Save]: 'Save',
  [LocalizationKeys.SBRM.Update]: 'Update',
  [LocalizationKeys.SBRM.AddNew]: 'Add new',
  [LocalizationKeys.SBRM.Duplicate]: 'Duplicate',
  [LocalizationKeys.SBRM.View]: 'View',
  [LocalizationKeys.SBRM.Comment]: 'Comment',
  [LocalizationKeys.SBRM.DeleteConfirmation]: 'Are you sure to delete ?',

  [LocalizationKeys.SBRMTitle.AddNew]: 'Add new {{type}}',
  [LocalizationKeys.SBRMTitle.CreateNew]: 'Create new {{type}}',
  [LocalizationKeys.SBRMTitle.Edit]: 'Edit {{type}}',
  [LocalizationKeys.SBRMTitle.Delete]: 'Delete {{type}}',
  [LocalizationKeys.SBRMTitle.Comment]: 'Comment {{type}}',
  [LocalizationKeys.SBRMTitle.View]: 'View {{type}}',
  [LocalizationKeys.SBRMTitle.Upload]: 'Upload {{type}}',
  [LocalizationKeys.SBRMTitle.Duplicate]: 'Duplicate {{type}}',
  [LocalizationKeys.SBRMTitle.Assign]: 'Assign {{type}}',
  [LocalizationKeys.SBRMTitle.Invite]: 'Invite {{type}}',
  [LocalizationKeys.SBRMTitle.Cancel]: 'Cancel {{type}}',

  [LocalizationKeys.Entity.user]: 'user',
  [LocalizationKeys.Entity.profile]: 'profile',
  [LocalizationKeys.Entity.automation]: 'automations',
  [LocalizationKeys.Entity.answer]: 'answers',
  [LocalizationKeys.Entity.contact]: 'contact',
  [LocalizationKeys.Entity.analyticsEvent]: 'analytics event',
}

export default English
